import { ButtonTarget } from 'fe-design-base/enums';
import Button from 'fe-design-base/molecules/Button';

import { CONTACT_US_ARTICLE_URL } from 'features/help/constants';

import { toI18n } from 'util/i18n';

// TODO: FE-2182 - will be adding ClickToCallDialog for logged in flows
const ContactUsButton = () => (
  <>
    <Button
      variant="secondary"
      href={CONTACT_US_ARTICLE_URL}
      target={ButtonTarget.BLANK}
    >
      {toI18n('fe_design_base.cta.contact_us')}
    </Button>
  </>
);

export default ContactUsButton;
